import { render, staticRenderFns } from "./CategoryBannerMobile.vue?vue&type=template&id=0249c85a"
import script from "./CategoryBannerMobile.vue?vue&type=script&lang=js"
export * from "./CategoryBannerMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports